import { DefaultState, Filters } from 'store/types';

export const SET_GUEST_TABLE_FILTERS = 'SET_GUEST_TABLE_FILTERS';

export type GuestTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetGuestTableFilters {
  type: typeof SET_GUEST_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type GuestTableFiltersActionTypes = SetGuestTableFilters;
